import React, { useContext, useEffect, useState } from "react";
import { Select, SelectItem } from "carbon-components-react";

import { operatorHumanizeLoanProgramName, SandboxResponseProgram } from "@eave/shared/types/api";

import InputForm from "./InputForm";
import Results from "./Results";
import { SandboxScenarioContext } from "../SandboxScenarioProvider";

const styles = require("./styles.module.scss");

const SandboxScenarioCalculator = () => {
  const { results } = useContext(SandboxScenarioContext);

  const [selectedProgram, setSelectedProgram] = useState<string | null>(null);

  useEffect(() => {
    if (results?.programs.length) {
      setSelectedProgram(results.programs[0].name);
    } else {
      setSelectedProgram(null);
    }
  }, [results]);

  return (
    <div className={styles.container}>
      <div className={styles.panels}>
        <h1 className={styles.title}>Loan sandbox &ndash; affordability</h1>
        <p className={styles.instructions}>
          Adjust the inputs below, then click <span>Run affordability</span>. This is only a
          calculator and outputs will not propagate back to the loan file.
        </p>
        <InputForm />
      </div>
      <div className={styles.panels}>
        {results && selectedProgram && (
          <>
            <Select
              id="program-name"
              name="program-name"
              value={selectedProgram}
              labelText="Loan program"
              onChange={e => setSelectedProgram(e.target.value)}
            >
              {results.programs.map((p: SandboxResponseProgram) => (
                <SelectItem
                  key={p.name}
                  text={operatorHumanizeLoanProgramName[p.name] || p.name}
                  value={p.name}
                />
              ))}
            </Select>
            <Results
              program={results.programs.find(
                (p: SandboxResponseProgram) => p.name === selectedProgram,
              )}
              err={results.error}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default SandboxScenarioCalculator;
